import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

export const fetchAllBirthdays = createAsyncThunk('birthdays/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const birthdays = await API.birthdays.getAll();
        return birthdays;
    } catch (error) {
        notification.error({ message: 'Error', description: error.message || 'Server error' });
        return rejectWithValue(error.message || 'Server error');
    }
});
